import { isIframe } from 'iframe-support'
import { getFlowType } from './url-utils'
import store from '../stores/configureStore'
import { post } from '../../calculator/lib/xhr'
import logger from 'loglevel'

export function handleInterstitialCipFlow(param) {
  let flowType = getFlowType(),
    entryPoint = 'P2P',
    feature = getFlowType() === 'buy' ? 'PURCHASE' : 'PERSONAL',
    amount = store.getState().amount.amount,
    token = store.getState().recipient.token,
    recipient = store.getState().recipient.recipient,
    payerId = store.getState().recipient.payerId,
    networkId = store.getState().recipient.networkId,
    displayName = store.getState().recipient.displayName,
    currencyCode = store.getState().amount.currencyCode,
    thumbnailUrl = store.getState().recipient.thumbnailUrl,
    subFlow = 'send',
    externalUrl =
      getFlowType() === 'buy'
        ? store.getState().user.purchaseCipUrl
        : store.getState().user.personalCipUrl,
    env = store.getState().server.env,
    flowIntent = store.getState().server.flowIntent
  if (typeof param === 'object') {
    flowType = param.flowType
    recipient = param.email
    thumbnailUrl = param.thumbnailUrl
    displayName = param.fullName
    payerId = param.payerId
    feature = flowType === 'buy' ? 'PURCHASE' : 'PERSONAL'
    externalUrl =
      flowType === 'buy'
        ? store.getState().user.purchaseCipUrl
        : store.getState().user.personalCipUrl
  }
  if (param === 'send' || param === 'buy') {
    flowType = param
    if (getFlowType() === 'payRequest') {
      env = 'payRequest'
      subFlow = 'pay_from_request'
    }
    feature = param === 'buy' ? 'PURCHASE' : 'PERSONAL'
    externalUrl =
      param === 'buy'
        ? store.getState().user.purchaseCipUrl
        : store.getState().user.personalCipUrl
  }
  const homeinfoPayLoad = {
    flowType,
    entryPoint,
    feature,
    amount,
    token,
    recipient,
    env,
    payerId,
    networkId,
    displayName,
    currencyCode,
    thumbnailUrl,
    externalUrl,
    subFlow,
    flowIntent,
  }
  const homeinfoFlowUrl = '/myaccount/transfer/flow/fi/aucip'
  const mainWindow = isIframe() ? window.top : window
  post(homeinfoFlowUrl, homeinfoPayLoad)
    .then(response => {
      const { redirectURL = {} } = response
      mainWindow.location.assign(redirectURL)
    })
    .catch(err => {
      logger.error(err)
    })
}
